<div class="layout-menu mt-4">
  <ul>
    <li
      *ngFor="let item of navigationItems; index as i"
      [ngClass]="{ 'sub-item-open': subMenuOpened === i }"
      routerLinkActive="active"
    >
      <a [routerLink]="[item.route]" routerLinkActive="active">
        <div class="icon"><i [class]="item.iconClass"></i></div>
        <div class="text">{{ item.label }}</div>
      </a>
    </li>
  </ul>
</div>
